export const joinPath = (...args: (number | string)[]) => {
  const value = args.join('/').replace(/\/+/g, '/');
  return value.endsWith('/') ? value : `${value}/`;
};
